module.exports = __webpack_public_path__ + "img/plus.8d35bdac.svg";